import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import { useAuth } from '../../services/AuthContext';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Função específica para o logout no menu mobile
  const handleMobileSignOut = () => {
    // Primeiro, fecha o menu
    setIsMobileMenuOpen(false);
    // Depois, executa o logout
    handleSignOut();
  };

  const menuItems = [
    { label: 'Home', path: '/#home' },
    { label: 'Comandos', path: '/comandos' },
    { label: 'Planos', path: '/#planos' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm shadow-sm">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="/assets/images/rnplugin-horizontal-onlight.png"
              alt="RNPlugin"
              width="128"
              height="32"
              className="h-8 w-auto"
            />
          </Link>

          {/* --- Menu Desktop --- */}
          <div className="hidden md:flex items-center space-x-8">
            <div className="space-x-6">
              {menuItems.map((item) =>
                item.path.includes('#') ? (
                  <a
                    key={item.path}
                    href={item.path}
                    className="text-rn-text-soft hover:text-rn-navy transition-colors"
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    key={item.path}
                    to={item.path}
                    className="text-rn-text-soft hover:text-rn-navy transition-colors"
                  >
                    {item.label}
                  </Link>
                )
              )}
            </div>
            <div className="flex items-center space-x-4">
              {user ? (
                <>
                  <Link to="/dashboard">
                    <Button variant="secondary" size="sm">
                      Dashboard
                    </Button>
                  </Link>
                  <Button onClick={handleSignOut} variant="secondary" size="sm">
                    Sair
                  </Button>
                </>
              ) : (
                <>
                  <Link to="/login">
                    <Button variant="secondary" size="sm">
                      Entrar
                    </Button>
                  </Link>
                  <Link to="/signup">
                    <Button variant="primary" size="sm">
                      Criar Conta
                    </Button>
                  </Link>
                </>
              )}
            </div>
          </div>

          {/* Botão do Menu Mobile */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100"
            aria-label="Menu"
          >
            <svg
              className="h-6 w-6 text-gray-600"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* --- Menu Mobile --- */}
        {isMobileMenuOpen && (
          <div className="md:hidden pt-4 pb-6">
            <div className="flex flex-col space-y-4">
              {menuItems.map((item) =>
                item.path.includes('#') ? (
                  <a
                    key={item.path}
                    href={item.path}
                    className="text-rn-text-soft hover:text-rn-navy transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    key={item.path}
                    to={item.path}
                    className="text-rn-text-soft hover:text-rn-navy transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                )
              )}

              {user ? (
                <>
                  <Link
                    to="/dashboard"
                    className="text-rn-text-soft hover:text-rn-navy transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Dashboard
                  </Link>
                  {/* CORREÇÃO: Usar a nova função dedicada */}
                  <button
                    onClick={handleMobileSignOut}
                    className="text-left text-red-600 hover:text-red-700 transition-colors"
                  >
                    Sair
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="text-rn-text-soft hover:text-rn-navy transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Entrar
                  </Link>
                  <Link
                    to="/signup"
                    className="text-rn-orange-text font-semibold transition-colors"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Criar Conta
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
